import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hyrelancer_frontend/hyrelancer/src/app/(public)/Footer/page.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hyrelancer_frontend/hyrelancer/src/app/(public)/Header/page.jsx");
;
import(/* webpackMode: "eager" */ "/home/hyrelancer_frontend/hyrelancer/src/styles/globals.css");
